import { render, staticRenderFns } from "./ManageGroup.vue?vue&type=template&id=7c81d9a7&scoped=true&"
import script from "./ManageGroup.vue?vue&type=script&lang=ts&"
export * from "./ManageGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ManageGroup.vue?vue&type=style&index=0&id=7c81d9a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81d9a7",
  null
  
)

export default component.exports